
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/attorneys/brewington",
      function () {
        return require("private-next-pages/attorneys/brewington/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/attorneys/brewington"])
      });
    }
  